import { dequal } from 'dequal';

import { V2_EVALUATOR_VERSION } from '@/Pages/Settings/utils/constants';
import { StructuredEvaluatorSchema } from '@/types/schema';

export function getEvaluatorVersion({
  oldEvaluator,
  newEvaluator,
  oldRuleEvaluatorVersion,
}: {
  oldEvaluator?: StructuredEvaluatorSchema;
  newEvaluator?: StructuredEvaluatorSchema;
  oldRuleEvaluatorVersion: number;
}) {
  const newVariableMapping = newEvaluator?.variable_mapping;
  const oldVariableMapping = oldEvaluator?.variable_mapping;
  const isVariableMappingSame = dequal(newVariableMapping, oldVariableMapping);

  return isVariableMappingSame
    ? oldRuleEvaluatorVersion
    : Math.max(oldRuleEvaluatorVersion, V2_EVALUATOR_VERSION);
}
